import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { LogService } from '@app/core/services/log.service';
import { TimePeriod, TimePeriods } from '@app/shared/models/time-period';
import { Client } from '@app/shared/models/client';
import { ClientUserUriBuilderParams, UserService } from '@app/core/services/user.service';
import { forkJoin } from 'rxjs';
import { BaseWithIdList, PaginatedList } from '@app/shared/models/list';
import { ClientUser, ClientUserQueryResult, ClientUserState } from '@app/shared/models/client-user';
import { TranslationEntry } from '@app/shared/models/translatable';
import {BillingLog, SMPLog} from '@app/shared/models/log';
import { DrI18nService } from '@app/core/services/i18n/i18n.service';
import {BillingLogService} from '@app/core/services/billing-log.service';


@Component({
    templateUrl: './billing-log.component.html',
    styleUrls: ['./billing-log.component.scss']
})
export class BillingLogComponent extends BaseWithBundleComponent
    implements OnInit, OnDestroy {

    public from: Date;
    public to: Date;
    public logs: PaginatedList<BillingLog>;
    public searchPerformed: boolean;

    constructor(protected componentServiceBundle: ComponentServiceBundle, protected logService: BillingLogService) {
        super(componentServiceBundle);
        this._idPrefix = 'billing_log.';
    }

    public ngOnInit() {
        super.ngOnInit();

        if (this.drI18nService.loadedTransFile) {
            this.initialize();
        } else {
            this.subscriptions.push(
                this.drI18nService.loadedTransFileSubject
                    .subscribe(result => {
                        if (result) {
                            this.initialize();
                        }
                    })
            );
        }
    }

    public ngOnDestroy() {
        super.ngOnDestroy();
    }

    protected initialize(): void {

        const allTranslated = `-- ${this.translateService.instant(marker('common.label.all'))} --`;

        // const dropDownEntryAll = {
        //     key: '',
        //     trans: allTranslated
        // };

        this.resetFilters();

        const observables = [
            this.logService.getLogs(),
        ];

        forkJoin(observables).subscribe((results: any) => {
            this.logs = results[0];
        }, err => {
            this.handleError(err);
        });
    }

    public switchToSpecific(): void {
        // used to switch the time period selector to the 'specific/other date' option
    }

    public resetFilters(): void {
        this.from = undefined;
        this.to = undefined;
    }

    public applyFilters(): void {
        this.searchPerformed = true;
        this.logService.getLogs(this.from, this.to)
            .subscribe(result => {
                this.logs = result;
            });
    }

}
